import React from 'react'
import {Outlet} from 'react-router-dom';
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";

const Outbounds = () => {
    return <React.Fragment>
        <DashboardLayout>
            <Outlet/>
        </DashboardLayout>
    </React.Fragment>
};

export default Outbounds;

